import React from 'react';
import Card from './Card';

interface MetricCardData {
  value: string | number;
  label: string;
  color?: 'primary' | 'success' | 'warning' | 'danger' | 'secondary';
  icon?: React.ReactNode;
}

interface MetricCardGridProps {
  metrics: MetricCardData[];
  columns?: 2 | 3 | 4;
  className?: string;
}

const MetricCardGrid: React.FC<MetricCardGridProps> = ({ 
  metrics, 
  columns = 4,
  className = ''
}) => {
  const colorClasses = {
    primary: 'text-primary-600 dark:text-primary-300',
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-error',
    secondary: 'text-secondary-600 dark:text-secondary-300'
  };

  const gridClasses = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
  };

  return (
    <div className={`grid ${gridClasses[columns]} gap-6 ${className}`}>
      {metrics.map((metric, index) => (
        <Card key={index} className="bg-white dark:bg-gray-800">
          <Card.Body>
            {metric.icon && <div className="mb-2">{metric.icon}</div>}
            <div className={`text-3xl font-bold ${colorClasses[metric.color || 'primary']}`}>
              {metric.value}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-300 mt-2">
              {metric.label}
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default MetricCardGrid;
